// extracted by css-extract-rspack-plugin
export default {"root":"aiQLU9","form":"h2gm1o"};